import { type Bounds, bounds } from '../elements/bounds';
import type { EdgePositions } from './EdgePositions';
import { getEdgeConvexHullPoints } from './positions';

/**
 * Get edge bounds without taking labels into account
 */
export const getEdgePositionsBounds = (edgePositions: EdgePositions): Bounds =>
  bounds.fromPolygon(getEdgeConvexHullPoints(edgePositions));
